import { Grid } from '@mantine/core';
import SummaryCard from '../../../components/Dashboard/SummaryCard';
import DashboardsCommon from '../../../components/DashboardsCommon';
import statsToSummary from '../../../constants/StatsToSummary';

const UserBaseTab = ({ stats, prevStats }) => {
  return (
    <>
      <div data-tour="userBaseTopStats">
        <Grid pt="sm">
          <SummaryCard
            currentPeriodData={statsToSummary(stats.totals.userBase)}
            previousPeriodData={statsToSummary(prevStats.totals.userBase)}
            currency=""
            size="3"
          />
        </Grid>
        <Grid mt="md">
          <Grid.Col span={{ base: 12, sm: 6 }}>
            <DashboardsCommon
              stats={stats.subscriptions.filter((stat) => stat.id === 'registered')}
              chartTitle="Registered Users"
              lineStacked={false}
              expand={true}
              type={'card'}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, sm: 6 }}>
            <DashboardsCommon
              stats={stats.subscriptions.filter((stat) => stat.id === 'subscribers')}
              chartTitle="Subscribers"
              lineStacked={false}
              expand={true}
              type={'card'}
            />
          </Grid.Col>
        </Grid>
      </div>
      <br />
      <Grid data-tour="userBaseSubscribesAndUnsubscribes">
        <Grid.Col span={12}>
          <DashboardsCommon
            stats={stats.subscriptions
              .filter((stat) => ['subscribes', 'unsubscribes'].includes(stat.id))
              .map((stat) => ({
                ...stat,
                color: stat.id === 'subscribes' ? 'var(--mantine-color-success-5)' : 'var(--mantine-color-danger-5)',
              }))}
            chartTitle="Subscribes and Unsubscribes"
            lineStacked={false}
            expand={false}
            type={'card'}
          />
        </Grid.Col>
      </Grid>
    </>
  );
};

export default UserBaseTab;
